// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"beaca459","977":"bd0712df"}[chunkId] + ".chunk.js";
};